export default {"src":"/_next/static/media/ellipse.072ee22b.svg","height":268,"width":610,"blurWidth":0,"blurHeight":0};